import countryCodes from './countryCodes';

type CountryOption = {
    code: string;
    name: string;
};

export const getCountryOptions = (language: string): CountryOption[] => {
    let locale = 'es';

    if (language.startsWith('en')) locale = 'en';
    else if (language.startsWith('ca')) locale = 'ca';
    else if (language.startsWith('gl')) locale = 'gl';
    else if (language.startsWith('eu')) locale = 'eu';

    const displayNames = new Intl.DisplayNames([locale], { type: 'region' });

    return countryCodes
        .map((code) => ({
            code,
            name: displayNames.of(code) || code,
        }))
        .sort((a, b) => a.name.localeCompare(b.name, locale));
};